import React, {FC} from 'react';
import styled from 'styled-components';

import {EmojiDefinition} from '../../../services/emojis/emojis';
import {SkinTonesEnum} from '../../../services/emojis/emojiTypes';
import {Emoji} from '../emoji/emoji';

/*
 * Props.
 */

interface BannerEmojiProps {
  emoji: EmojiDefinition;
  skinTone?: SkinTonesEnum;
}

/*
 * Style.
 */

const StyledEmojiDiv = styled.div`
  grid-area: icon;
  margin: 10px 0;
`;

/*
 * Component.
 */

export const BannerEmoji: FC<BannerEmojiProps> = (props) => (
  <StyledEmojiDiv>
    <Emoji {...props} size={16} />
  </StyledEmojiDiv>
);
